import React from 'react';

const CatSVG = ({ color }) => (
    <svg width="60px" height="60px" viewBox="0 0 24 24" strokeWidth="2.1" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path d="M10.5 9C10.5 9 10.5 7 9.5 5C13.5 5 16 7.49997 16 7.49997C16 7.49997 19.5 7 22 12C21 17.5 16 18 16 18L12 20.5C12 20.5 12 19.5 12 17.5C9.5 16.5 6.99998 14 7 12.5C7.00001 11 10.5 9 10.5 9ZM10.5 9C10.5 9 11.5 8.5 12.5 8.5" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M2 9.5L3 12.5L2 15.5C2 15.5 7 15.5 7 12.5C7 9.5 2 9.5 2 9.5Z" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M17 12.01L17.01 11.9989" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
);

export default CatSVG;
